module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"message.api_error.title":"Drone S/N : {serialNo} พบข้อผิดพลาด","message.api_error.description":"พบข้อผิดพลาดในระบบ กรุณาลองใหม่อีกครั้ง หรือ ติดต่อ Support","message.drone_not_found.title":"Drone S/N : {serialNo} ไม่มีในระบบ","message.drone_not_found.description":"กรุณาตรวจสอบ S/N ที่ระบุมาอีกครั้ง ผ่าน HGMC"}}')
  delete Component.options._Ctor
}
